<template>
    <div class="mt-3">
        <b-card>
            <b-card-body>
                <div class="mb-3">
                    <h6 class="mb-1">Update Attendance Punches</h6>
                    <small class="text-muted">
                        Add attendance punch times. Also with mobility type can be selected.
                    </small>
                </div>

                <div v-for="(row, index) in attendance_hits" :key="index" class="border rounded p-3 mb-2">
                    <b-row>
                        <b-col cols="12" md="5">
                            <b-form-group :label="index === 0 ? 'Punch Time' : ''" :label-for="'hit_time_' + index">
                                <b-form-input :id="'hit_time_' + index" v-model="row.hit_time" type="time" step="60"
                                    placeholder="HH:mm"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="5">
                            <b-form-group :label="index === 0 ? 'Mobility' : ''" :label-for="'mobility_' + index">
                                <b-form-select :id="'mobility_' + index" v-model="row.mobility_id"
                                    :options="mobilities"></b-form-select>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="2" class="d-flex align-items-end">
                            <b-button variant="outline-danger" class="mb-3" :disabled="attendance_hits.length === 1"
                                @click="removeAttendanceHit(index)">
                                <b-icon icon="trash"></b-icon>
                            </b-button>
                        </b-col>
                    </b-row>
                </div>

                <div class="d-flex justify-content-between mt-3">
                    <b-button class="custom-wizard-btn" variant="primary" @click="addAttendanceHit">
                        Add More
                    </b-button>

                    <b-button variant="primary" @click="submitAttendanceHits">
                        Submit Attendance
                    </b-button>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    export default {
        props: ['employee_id', 'date'],

        data() {
            return {
                mobilities: [],
                attendance_hits: [
                    {
                        hit_time: '',
                        mobility_id: 0,
                    }
                ],
            };
        },

        methods: {
            getMobilities() {
                axios.get(this.$api_url + '/leave-attendance/attendance-mobility').then(response => {
                    this.mobilities = [{
                        value: 0,
                        text: 'None'
                    }, ...response.data.filter(el => el.status == 1).map(el => {
                        return {
                            value: el.id,
                            text: el.location
                        };
                    })];
                }).catch(error => {
                    this.serverError(error);
                });
            },

            addAttendanceHit() {
                this.attendance_hits.push({
                    hit_time: '',
                    mobility_id: 0,
                });
            },

            removeAttendanceHit(index) {
                if (this.attendance_hits.length === 1) return;
                this.attendance_hits.splice(index, 1);
            },

            submitAttendanceHits() {
                const hits = this.attendance_hits.filter(row => row.hit_time).map(row => ({
                    hit_time: row.hit_time,
                    mobility_id: row.mobility_id,
                }));

                let formData = new FormData();

                formData.append('attendance_hits', JSON.stringify(hits));
                formData.append('employee_id', this.employee_id);
                formData.append('date', this.date);

                axios.post(this.$api_url + '/leave-attendance/attendance/update-hits', formData)
                    .then(response => {
                        this.$bvToast.toast(response.data.message, {
                            title: 'Success',
                            variant: 'success',
                            solid: true
                        });

                        this.$emit('onUpdate');
                    })
                    .catch(error => {
                        this.serverError(error);
                    });
            },
        },

        created() {
            this.getMobilities();
        }
    };
</script>